import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-rental-agreement.dto';
export * from './dtos/rental-agreement-links.dto';
export * from './dtos/rental-agreement-list.dto';
export * from './dtos/rental-agreement-record.dto';
export * from './dtos/rental-agreement-activity-event.dto';
export * from './dtos/rental-agreement-activity-event-hydration.dto';
export * from './dtos/rental-agreement-search.dto';
export * from './dtos/rental-agreements-stats.dto';
export * from './dtos/update-rental-agreement.dto';

export * from './enums/rental-agreement-action.enum';
export * from './enums/rental-agreement-record-category.enum';
export * from './enums/rental-agreement-status.enum';
export * from './enums/rental-agreement-type.enum';
export * from './enums/rental-party-source-type.enum';

export * from './functions/rental-agreement-status-to-color.function';

export * from './types/rental-agreements-filters';

export * from './validators/schemas/create-rental-agreement.schema';
export * from './validators/schemas/update-rental-agreement.schema';

export const rentalAgreementValidators = {
  canCreateOrUpdate,
  canPerformAction,
};
